/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PreviewDocument/Content/Content/PdfFile/Actions/Signature/Content"
  
}) {
let constantData = 'Document addressed to'
let signatureSignatoryPersonFirstNameValueData = fromData.useDataValue({ viewPath,
context: 'signature',
path: 'signatory_person.first_name',
})
let signatureSignatoryPersonLastNameValueData = fromData.useDataValue({ viewPath,
context: 'signature',
path: 'signatory_person.last_name',
})
let constantData1 = 'signed on'
let signatureSignedAtValueData = fromData.useDataFormat({ viewPath,
context: 'signature',
path: 'signed_at',
format: fromFormat.dateISOToDateAndTimeShort,
})
let aggregateData = fromAggregate.join(constantData, signatureSignatoryPersonFirstNameValueData, signatureSignatoryPersonLastNameValueData, constantData1, signatureSignedAtValueData)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="'Document addressed to'"
 data="signature.signatory_person.first_name"
 data="signature.signatory_person.last_name"
 data="'signed on'"
 data="signature.signed_at"
 format="/Data/format.js dateISOToDateAndTimeShort"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}